import store from '../store'
import Policy from '../policy/index'

export default [
  {
    path: '/login',
    component: () => import('layouts/Landing'),
    beforeEnter: verifyEmail,
    children: [
      { path: '', component: () => import('pages/Login') }
    ]
  },
  {
    path: '/forgotpassword',
    component: () => import('layouts/Landing'),
    icon: 'people_outline',
    children: [
      { path: '', component: () => import('pages/ForgotPassword') }
    ]
  },
  {
    path: '/attend',
    component: () => import('layouts/Landing'),
    icon: 'people_outline',
    children: [
      { path: '', component: () => import('pages/Attend') }
    ]
  },
  {
    path: '/',
    redirect: '/users', // Default Route
    beforeEnter: requireAuth,
    component: () => import('layouts/Main'),
    children: [
      {
        path: '/users',
        name: 'Users',
        icon: 'user',
        component: () => import('pages/Users'),
        meta: {
          module: 'users'
        }
      },
      {
        path: '/students',
        name: 'Students',
        icon: 'fa fa-users',
        component: () => import('pages/Students'),
        meta: {
          module: 'students'
        }
      },      
      {
        path: '/classes',
        name: 'Classes',
        icon: 'date range',
        component: () => import('pages/Wrapper'),
        redirect: '/classes/list',
        children: [
          {
            path: 'list',
            name: 'Class List',
            component: () => import('pages/ClassList'),
            meta: {
              module: 'classes'
            }
          },
          {
            path: 'calendar',
            name: 'Class Calendar',
            component: () => import('pages/ClassSchedule'),
            meta: {
              module: 'classes'
            }
          }
        ]
      },
      {
        path: '/approvals',
        name: 'Approvals',
        icon: 'access time',
        component: () => import('pages/Wrapper'),
        redirect: '/approvals/classes',
        meta: {
          module: 'approvals'
        },
        children: [
          {
            path: 'classes',
            name: 'Class Approvals',
            icon: 'access time',
            component: () => import('pages/ClassApprovals'),
            meta: {
              module: 'classApprovals'
            }
          },
          {
            path: 'instructors',
            name: 'Instructor Approvals',
            component: () => import('pages/InstructorApprovals'),
            icon: 'school',
            meta: {
              module: 'instructorApprovals'
            }
          }
        ]
      },    
      {
        path: '/courses',
        name: 'Courses',
        component: () => import('pages/Courses'),
        meta: {
          module: 'courses'
        }
      },      
      {
        path: '/orders',
        name: 'Orders',
        component: () => import('pages/Orders'),
        meta: {
          module: 'orders'
        }
      },
      {
        path: '/reports',
        name: 'Reports',
        component: () => import('pages/Reports'),
        meta: {
          module: 'reports'
        },
        children: [
          {
            selected: false,
            title: 'Certificates',
            path: '/reports/#!/certificates',            
            component: () => import('pages/Reports'),
            icon: 'bookmark outline'
          },
          {
            selected: false,
            title: 'Schedule Report',
            path: '/reports',
            component: () => import('pages/Reports'),
            icon: 'timeline'
          },
          {
            selected: false,
            title: 'Referral Report',
            path: '/reports',
            component: () => import('pages/Reports'),
            icon: 'monetization on'
          },
          {
            selected: false,
            title: 'Student Completion',
            path: '/reports',
            component: () => import('pages/Reports'),
            icon: 'how to reg'
          }
        ]
      },
      {
        path: '/certificates',
        name: 'Certificates',
        component: () => import('pages/Certificates'),
        icon: 'fa fa-file-contract',
        meta: {
          module: 'certificates'
        }
      },
      {
        path: '/resources',
        name: 'Resources',
        redirect:'/resources/documents',
        component: () => import('pages/Wrapper'),
        meta: {
          module: 'resources'
        },
        children: [
          {
            path: 'documents',
            name: 'Documents',
            component: () => import('pages/Documents'),
            meta: {
              module: 'documents'
            }
          }
        ]
      },
      {
        path: '/eventlog',
        name: 'Event Log',
        component: () => import('pages/EventLog'),
        icon: 'fa fa-arrow',
        meta: {
          module: 'events'
        }
      },
      {
        path: '/jobs',
        name: 'Jobs',
        component: () => import('pages/Jobs'),
        icon: 'fa fa-arrow',
        meta: {
          module: 'jobs'
        }
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('pages/Settings'),
        icon: 'fa fa-cog',
        meta: {
          module: 'settings'
        }
      },
    ]
  },
  { // Always leave this as last one
    path: '*',
    component: () => import('pages/404')
  }
]

async function requireAuth (to, from, next) {
  // if (!process.env.DEV) {
    const userToken = store.getters['auth/getUserToken']
    if (userToken) store.dispatch('auth/checkUserToken', userToken)
    if (to.path === '/login') { return next() }
    if (userToken) { 
      const response = await store.dispatch('auth/checkUserToken', userToken)
      if (response) {
        next() 
      } else {
        store.dispatch('auth/logout')
        next('/login')
      }
    } else {
      store.state.auth.redirectUrl = to.path
      next('/login')
    }
  // }
  next()
}

function verifyEmail (to, from, next) {
  const verificationToken = to.query.token
  // console.log('verification token', verificationToken)
  if (verificationToken) {
    store.dispatch('auth/verifyEmail', { verificationToken })
  }
  next()
} 
